import { render, staticRenderFns } from "./TikTok.vue?vue&type=template&id=61e34625&scoped=true&"
import script from "./TikTok.vue?vue&type=script&lang=js&"
export * from "./TikTok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e34625",
  null
  
)

export default component.exports